import { DATE_TIME_ISO_FORMAT, dateFormatter } from '@/shared/lib/date-formatting';
import { IFillWarehouseBagData } from '../ts';
import { IAgriculture } from '@/modules/agriculture/ts';
import { isDateNotLaterThanToday } from './format-date.function';
import { notification } from 'antd';

export function onSubmit(
  event: React.FormEvent<HTMLFormElement> | null,
  {
    selectedCulture,
    warehouseId,
    inputs,
    fillWarehouseBagLocal,
    id,
    agricultureById,
  }: IObj,
) {
  event && event.preventDefault();
  const checkDate = inputs.fillDate && isDateNotLaterThanToday(inputs.fillDate);
  // if (!checkDate)
  //   return notification.error({
  //     message: 'Ошибка',
  //     description: 'Дата заполнения не может быть позднее сегодняшнего дня',
  //   });

  const data = {
    agriculture_id: selectedCulture,
    warehouse_id: warehouseId,
    weight: Number(inputs.weight),
    custom_name: inputs.custom_name,
    description: inputs.description,
    filling_date: dateFormatter(inputs.fillDate).format(DATE_TIME_ISO_FORMAT),
    parameters: Object.entries(inputs.parameters).reduce((acc, [id, value]) => {
      const parameterIndex = agricultureById[
        selectedCulture as number
      ].parameters.findIndex((parameter: any) => parameter.id === +id);
      // TODO: после привязки к ид, изменить
      const parameterName =
        agricultureById[selectedCulture as number].parameters[parameterIndex].name;

      // if (parameterName === 'Тип' || parameterName == 'Класс') {
      //   if (value && Number(value) <= 0 || isNaN(+value)) notification.warning({ message: 'Выберите сорт/тип пшеницы' });
      // }
      return {
        ...acc,
        [parameterName]: value,
      };
    }, {}),
  } as IFillWarehouseBagData;

  let errors = 0;
  if (agricultureById[selectedCulture].name === 'Пшеница' && !data.parameters['Тип']) {
    errors++;
    notification.warning({ message: 'Выберите сорт/тип пшеницы' });
  }
  // if (data.parameters['Тип'] && Number(data.parameters['Тип']) <= 0) {
  //   errors + 1;
  //   notification.warning({ message: 'Выберите тип пшеницы' });
  // }

  if (
    (selectedCulture === 1 && isNaN(+data.parameters['Класс'])) ||
    +data.parameters['Класс'] <= 0
  ) {
    errors++;
    notification.error({
      message:
        'Ошибка сервера: Не удалось определить класс. Попробуйте, пожалуйста, позже',
    });
  }

  if (
    (selectedCulture === 1 && isNaN(+data.parameters['Клейковина'])) ||
    +data.parameters['Клейковина'] <= 0
  ) {
    errors++;

    notification.warning({ message: 'Укажите значение для поля "клейковина"' });
  }

  if (
    (selectedCulture === 1 && isNaN(+data.parameters['Температура'])) ||
    +data.parameters['Температура'] <= 0
  ) {
    errors++;

    notification.warning({ message: 'Укажите значение для поля "температура"' });
  }

  if (
    (selectedCulture === 1 && isNaN(+data.parameters['ИДК'])) ||
    +data.parameters['ИДК'] <= 0
  ) {
    errors++;
    notification.warning({ message: 'Укажите значение для поля "ИДК"' });
  }

  if (
    (selectedCulture === 1 && isNaN(+data.parameters['Влажность культуры'])) ||
    +data.parameters['Влажность культуры'] <= 0
  ) {
    errors++;
    notification.warning({ message: 'Укажите значение для поля "влажность культуры"' });
  }

  if (
    (selectedCulture === 1 && isNaN(+data.parameters['Число падения'])) ||
    +data.parameters['Число падения'] <= 0
  ) {
    errors++;
    notification.warning({ message: 'Укажите значение для поля "число падения"' });
  }

  if (
    (selectedCulture === 1 && isNaN(+data.parameters['Протеин'])) ||
    +data.parameters['Протеин'] <= 0
  ) {
    errors++;
    notification.warning({ message: 'Укажите значение для поля "протеин"' });
  }

  if (
    (selectedCulture === 1 && isNaN(+data.parameters['Натура'])) ||
    +data.parameters['Натура'] <= 0
  ) {
    errors++;
    notification.warning({ message: 'Укажите значение для поля "натура"' });
  }

  if (isNaN(+data.weight) || +data.weight <= 0) {
    errors++;
    notification.warning({ message: 'Укажите корректный вес' });
  }

  if (errors >= 1) return;
  fillWarehouseBagLocal({
    bagId: id,
    data,
  });
}

interface IObj {
  selectedCulture: number;
  warehouseId: string | number;
  inputs: {
    weight: string;
    fillDate: Date | null;
    parameters: Record<number, string>;
    wheatType?: number | undefined;
    description?: string;
    custom_name?: string | number;
  };
  fillWarehouseBagLocal: any;
  id: number | string;
  agricultureById: Record<number, IAgriculture>;
}
